import { getPluralForm } from './getPluralForm'

export const getFormattedDeclinableDate = (year: number, month: number) => {
	const formattedYear = `${year} ${getPluralForm(year, 'год', 'года', 'лет')}`
	const formattedMonth = `${month} ${getPluralForm(month, 'месяц', 'месяца', 'месяцев')}`

	return `${formattedYear} ${formattedMonth}`
}
